export default "__VITE_ASSET__BqRdF4ve__"